import React from 'react';
import { ErrorGlobal } from '@xingternal/content-error';
import { Status } from '@xingternal/hops';
import styles from './PageError.css';

type PageErrorProps = {
  errorCode?: string;
};

const PageError: React.FC<PageErrorProps> = ({ errorCode = '503' }) => {
  return (
    <div className={styles.container}>
      <Status key={errorCode} code={parseInt(errorCode)} />
      <ErrorGlobal type={errorCode} />
    </div>
  );
};
export { PageError };
